import React, { createContext, useContext, useEffect, useState } from "react";

interface ClinicOfficesContextType {
  clinicOfficeId: string;
  setClinicOfficeId: (id: string) => void;
}

const ClinicOfficesContext = createContext<
  ClinicOfficesContextType | undefined
>(undefined);

export const useClinicOffices = () => {
  const context = useContext(ClinicOfficesContext);
  if (!context) {
    throw new Error(
      "useClinicOffices must be used within a ClinicOfficesProvider"
    );
  }
  return context;
};

interface ClinicOfficesProviderProps {
  children: React.ReactNode;
}

export const ClinicOfficesProvider = ({
  children,
}: ClinicOfficesProviderProps) => {
  const [clinicOfficeId, setClinicOfficeId] = useState<string>("all");

  useEffect(() => {
    const fetchClinicOfficeId = async () => {
      try {
        const storedId = localStorage.getItem("clinicOfficeId");
        const fetchedId = storedId || "Fetched Clinic Office ID"; // Fallback to fetched data or a default
        setClinicOfficeId(fetchedId);
      } catch (error) {
        console.error("Error fetching clinic office ID:", error);
      }
    };
    fetchClinicOfficeId();
  }, []);

  const updateClinicOfficeId = (id: string) => {
    setClinicOfficeId(id);
    localStorage.setItem("clinicOfficeId", id); // Save selected ID to localStorage
  };

  return (
    <ClinicOfficesContext.Provider
      value={{ clinicOfficeId, setClinicOfficeId: updateClinicOfficeId }}
    >
      {children}
    </ClinicOfficesContext.Provider>
  );
};
